<template>
  <div class="grad">
    <section class="bg-cover" :style="bgImg" id="Home">
      <div class="container-fluid container-fluid--cp-150 tt">
        <div class="main-content" data-aos="zoom-in-up">
          <h5 class="name">{{ i18n("app.title") }}</h5>
          <h1 class="title">{{ i18n("title") }}</h1>
          <h5 class="desc">
            {{ i18n("app.desc") }}
          </h5>
          <div class="actions">
            <b-nav-item @click="handleroute()" href="#about" class="scroll"
              ><span style="color: white">{{
                i18n("navbar.about")
              }}</span></b-nav-item
            >
            <b-nav-item @click="handleroute()" href="#services" class="scroll"
              ><span style="color: white">{{
                i18n("navbar.services")
              }}</span></b-nav-item
            >
            <!-- <a href="#about">About us</a>
            <a href="#services">Our services</a> -->
          </div>
        </div>
      </div>
      <div class="shape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="1440"
          height="150"
          preserveAspectRatio="none"
          viewBox="0 0 1440 150"
        >
          <g mask='url("#SvgjsMask1022")' fill="none">
            <path
              d="M 0,58 C 144,73 432,131.8 720,133 C 1008,134.2 1296,77.8 1440,64L1440 250L0 250z"
              fill="rgba(255, 255, 255, 1)"
            ></path>
          </g>
          <defs>
            <mask id="SvgjsMask1022">
              <rect width="1440" height="250" fill="#ffffff"></rect>
            </mask>
          </defs>
        </svg>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: {
        backgroundImage: `url(${"https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Fhero%2Fhome.webp?alt=media&token=81702b6a-cf04-4b66-91ac-f2930b3ddf00"})`,
      },
    };
  },

  methods: {
    i18n(key, args) {
      return this.$t(key, args);
    },
    handleroute() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variabls.scss";
@import "../assets/scss/elements/hero-branding.scss";

.grad {
  height: 92dvh !important;
  position: relative;
}
.tt {
  height: 100%;
}
section {
  height: 100%;
}
.main-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 650px;
  margin: auto;
  text-align: center;
}
.name {
  font-size: 15px;
  color: white;
  font-size: 15px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 10px;
}
.title {
  color: white;

  font-size: 40px;
  margin-bottom: 20px;
  font-weight: 700;
}
.desc {
  margin-top: 0;
  margin-bottom: 1rem;
  line-height: 1.6;
  font-size: 17px;
  color: rgba(255, 255, 255, 0.5) !important;
}

.actions {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}
.actions a {
  background: #173464;
  color: white;
  padding: 12px 30px;
  border-radius: 5px;
  cursor: pointer;
}

.actions a:hover {
  box-shadow: 0px 8px 20px -8px #5376ae74;
}

.hero-branding {
  text-align: center !important;
}
.shape {
  position: absolute;

  bottom: 0px;
  left: 0px;
  right: 0px;
}
svg {
  width: 100%;
  height: auto;
  vertical-align: middle;
}
@media (width < 768px) {
  .name {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .title {
    font-size: 25px;
  }
  .desc {
    font-size: 15px;
  }

  .actions a {
    padding: 9px 28px;
  }
}
</style>
